export default "__VITE_ASSET__70f8db66__"